import { isDevelopment } from '@pn/core/utils/env';
import { isEmpty, set } from 'lodash-es';
import type { MapboxIMap } from '..';

export const filterLayer: MapboxIMap['filterLayer'] = function (
  this: MapboxIMap,
  { layerId, key, filter }
) {
  if (!this.hasLayer(layerId)) return;

  set(this.filters, `${layerId}.${key}`, filter);

  const allLayerFilters = Object.values(this.filters[layerId]).filter(Boolean);

  if (isEmpty(allLayerFilters)) {
    this._native.setFilter(layerId, undefined);
  } else if (allLayerFilters.length === 1) {
    this._native.setFilter(layerId, allLayerFilters[0], {
      validate: isDevelopment(),
    });
  } else {
    this._native.setFilter(layerId, ['all', ...allLayerFilters], {
      validate: isDevelopment(),
    });
  }
};
